// About 200 DPI: sharp enough for Textract without making a page canvas huge.
export const RENDER_SCALE = 200 / 72

// Renders one page of a pdf.js document to a canvas, along with the canvas pixels per page unit.
export const pdfPageRenderer = (pdf) => async (pageNumber) => {
  const page = await pdf.getPage(pageNumber)
  const viewport = page.getViewport({ scale: RENDER_SCALE })
  const canvas = document.createElement('canvas')
  canvas.width = Math.ceil(viewport.width)
  canvas.height = Math.ceil(viewport.height)
  await page.render({ canvasContext: canvas.getContext('2d'), viewport }).promise
  return { canvas, scale: RENDER_SCALE }
}

// Small renderings are enough to find receipts on a page.
export const PREVIEW_SIZE = 600

export const pdfPagePreviewer = (pdf) => async (pageNumber) => {
  const page = await pdf.getPage(pageNumber)
  const base = page.getViewport({ scale: 1 })
  const scale = PREVIEW_SIZE / Math.max(base.width, base.height)
  const viewport = page.getViewport({ scale })
  const canvas = document.createElement('canvas')
  canvas.width = Math.ceil(viewport.width)
  canvas.height = Math.ceil(viewport.height)
  await page.render({ canvasContext: canvas.getContext('2d'), viewport }).promise
  return { canvas, scale }
}

export const toBlob = (canvas, type, quality) =>
  new Promise((resolve, reject) =>
    canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error('The receipt image could not be created.'))), type, quality)
  )

const JPEG = { extension: 'jpg', type: 'image/jpeg' }
const PNG = { extension: 'png', type: 'image/png' }

// Cuts a box out of a rendered page and turns it upright, so the crop holds only what the box covers.
// Photos stay JPEG; anything else is PNG unless that would reach maxBytes.
export const cropBox = async ({ canvas, scale }, box, { maxBytes, preferJpeg = false }) => {
  const out = document.createElement('canvas')
  out.width = Math.max(1, Math.round(box.w * scale))
  out.height = Math.max(1, Math.round(box.h * scale))
  const ctx = out.getContext('2d')
  ctx.fillStyle = '#ffffff'
  ctx.fillRect(0, 0, out.width, out.height)
  ctx.translate(out.width / 2, out.height / 2)
  ctx.rotate((-box.angle * Math.PI) / 180)
  ctx.drawImage(canvas, -box.cx * scale, -box.cy * scale)

  if (!preferJpeg) {
    const png = await toBlob(out, PNG.type)
    if (png.size < maxBytes) return { blob: png, ...PNG }
  }
  return { blob: await toBlob(out, JPEG.type, 0.92), ...JPEG }
}
